import { z } from 'zod';

const shopCriteriaItemSchema = z.object({
    attribute: z.string().min(1),
    value: z.array(z.string()).min(1),
});

const shopCriteriaGroupSchema = z.array(shopCriteriaItemSchema).min(1);

export const shopCriteriaSchema = z.object({
    groups: z.array(shopCriteriaGroupSchema),
    include: z.array(z.string()).optional(),
    exclude: z.array(z.string()).optional(),
});
